import { Injectable } from '@angular/core';

@Injectable()
export class SampleUserService {

  username = 'ActualUsername';

  constructor() {
  }

}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/sample-banner/sample-user.service.ts